import { z } from 'zod';
export const PaginationSchema = z.object({
    page: z.number().int().positive(),
    limit: z.number().int().positive().max(100),
    total: z.number().int().nonnegative(),
    totalPages: z.number().int().nonnegative(),
});
/**
 * Pagination *query* schema — what the client sends. Uses `z.coerce` so
 * `?page=2&limit=20` works directly from URL strings.
 */
export const PaginationQuerySchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce.number().int().positive().max(100).default(20),
});
/**
 * Wraps an item schema into a paginated `{ items, pagination }` shape. The
 * envelope is applied at the wire layer; this represents the inner `data`.
 */
export function PaginatedSchema(item) {
    return z.object({
        items: z.array(item),
        pagination: PaginationSchema,
    });
}
//# sourceMappingURL=pagination.js.map